import { render, staticRenderFns } from "./trialRoom.vue?vue&type=template&id=3ae97660"
import script from "./trialRoom.vue?vue&type=script&lang=js"
export * from "./trialRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports